export function isAdminOfAnyTeam(teams) {
    return (teams || []).some((team) => team.is_admin);
}
